module.exports = __webpack_public_path__ + "static/st2-11-04fdef7cc485c0eee199e67cd3a5ce34.jpg";